/* istanbul ignore file */
import { useCallback, useEffect, } from 'react';
import { getSessionStorage } from '@bingads-webui/storage';
import { useAdsStudioServices, getTaskPoller } from '../services';

// use session storeage to sync the in progress tasks count between
// asset-library pages and summary bar

const KEY = 'ASSET_LIBRARY_STORAGE';

const updateInProgressTasksStatus = (inProgressTaskCount) => {
  const ss = getSessionStorage();
  if (ss.supportsStorage()) {
    if (inProgressTaskCount > 0) {
      ss.set(KEY, { inProgressTaskCount });
    } else {
      ss.invalidate(KEY);
    }
  }
};

const clearInProgressTaskStatus = () => updateInProgressTasksStatus(0);

export const ImageCroppingTaskStatusPoller = ({ interval }) => {
  //
  const { getImageCroppingTaskStatus, croppingTaskUpdated } = useAdsStudioServices();

  const startImageCroppingTaskStatusPoller = useCallback(() => {
    const taskPoller = getTaskPoller({
      task: () => getImageCroppingTaskStatus().then((res) => {
        const { totalCount } = res || {};
        updateInProgressTasksStatus(totalCount || 0);
        return { isFinished: totalCount === 0 };
      }),
      interval,
    });
    taskPoller.start();
    const stopPoller = () => {
      taskPoller.stop();
      clearInProgressTaskStatus();
    };
    return { stopPoller };
  }, [getImageCroppingTaskStatus, interval]);

  // query in progress task stasus, and update summary-bar status accordingly
  useEffect(() => {
    const { stopPoller } = startImageCroppingTaskStatusPoller();
    return () => stopPoller();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [croppingTaskUpdated]);

  return null;
};
